import { CardHeaderProps, CardHeader as MuiCardHeader } from "@mui/material";

type Props = { restrictContentWidth?: boolean } & CardHeaderProps;

export const CardHeader = ({ restrictContentWidth = true, children, sx, ...props }: Props) => {
  return (
    <MuiCardHeader sx={{ maxWidth: (theme) => (restrictContentWidth ? theme.breakpoints.values.md : "none"), ...sx }} {...props}>
      {children}
    </MuiCardHeader>
  );
};
